<template>
  <div class="order">
    <van-sticky>
      <van-nav-bar title="预约管理" left-arrow @click-left="goback()" />
    </van-sticky>
    <van-tabs v-model="activeTop" title-active-color="#2295ff" color="#2295ff" @click="onClickTabsTop">
      <van-tab v-for="(item, index) in titleTop" :key="index" :title="item">
      </van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="order_centent">
          <van-tabs v-model="active" title-active-color="#2295ff" color="#2295ff" @click="onClickTabs">
            <van-tab v-for="(item, index) in title" :key="index" :title="item">
              <div class="content_number">{{ badgeNumber }}</div>
              <template v-for="(items, indexs) in orderList">
                <div class="order_list" :key="indexs" v-if="activeTop == 0">
                  <!-- 订单详情 -->
                  <div class="list_detail">
                    <van-image height="80" width="80" :src="items.siteVo.videoList.length > 0 ? items.siteVo.videoList[0].thumbnailUrl : items.siteVo.coverImageUrl" fit="cover" radius="7" />
                    <div class="list_desc fs11 color999">
                      <div class="line1 fs16 color000">
                        {{ items.siteVo.name }}
                      </div>
                      <div>
                        租金：{{ items.siteVo.monthlyRent }}元/月
                        &nbsp;&nbsp;&nbsp;&nbsp; 面积：40㎡
                      </div>
                      <div>预约看房时间：{{ items.siteVo.area }}</div>
                      <div>
                        姓名{{ items.contactName }}({{
                        items.contactGender_name
                        }})&nbsp;&nbsp;&nbsp;&nbsp;电话：{{
                        items.contactNumber
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="list_message">
                    {{ items.remark }}
                  </div>
                  <div class="list_btn">
                    <div class="fs13 color999">
                      提交时间：{{ items.createtime }}
                    </div>
                    <!-- <div class="btn">
                      <van-button size="small" color="#F70B0B" @click="callPhone(items.contactNumber)">一键呼叫</van-button>
                      <van-button size="small" v-if="items.followUpStatus === '0'" type="info"
                        @click="reservationVisitUpdateStatus(items.id)">标记跟进</van-button>
                    </div> -->
                  </div>
                </div>
                <div class="order_list" :key="indexs" v-if="activeTop == 1">
                  <!-- 订单详情 -->
                  <div class="list_detail">
                    <van-image height="80" width="80" :src="items.user_portrait" fit="cover" radius="7" />
                    <div class="list_desc fs11 color999">
                      <div class="line1 fs16 color000">
                        {{ items.siteVo.name }}
                      </div>
                      <div>
                        租金：{{ items.siteVo.monthlyRent }}元/月
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        订单编号：{{ items.order_info_orderNumber }}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        预约类型：{{ items.type_name }}
                      </div>
                      <div>上门时间：{{ items.onSiteDate }}-{{items.onSiteTime}}</div>
                      <div>
                        用户昵称{{ items.user_nickname }}&nbsp;&nbsp;&nbsp;&nbsp;处理状态：{{
                        items.status_name
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="list_message">
                    {{ items.remark || '暂无备注' }}
                  </div>
                  <div class="list_btn">
                    <div class="fs13 color999">
                      提交时间：{{ items.createtime }}
                    </div>
                    <!-- <div class="btn">
                      <van-button size="small" color="#F70B0B" @click="callPhone(items.contactNumber)">一键呼叫</van-button>
                      <van-button size="small" v-if="items.followUpStatus === '0'" type="info"
                        @click="reservationVisitUpdateStatus(items.id)">标记跟进</van-button>
                    </div> -->
                  </div>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-overlay :show="showOverlay" @click="show = false">
      <div class="mask_loading">
        <van-loading color="#0094ff" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Search,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Overlay,
} from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Search.name]: Search,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      showOverlay: false,
      searchValue: "",
      active: 0,
      title: ["全部", "待跟进", "已跟进"],
      activeTop: 0,
      titleTop: ["预约看房", "上门预约"],
      badgeNumber: 0,
      params: {
        status: "",
        keyword: "",
        page: 1,
        size: 8,
      },
      //订单列表
      orderList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    // 订单-列表
    this.orderInfoUserH5List();
  },

  methods: {
    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        if (that.activeTop == 0)
          // 预约-列表
          that.orderInfoUserH5List();
        if (that.activeTop == 1)
          // 上门-列表
          that.doorSupplierListAPI();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        if (that.activeTop == 0)
          // 预约-列表
          that.orderInfoUserH5List();
        if (that.activeTop == 1)
          // 上门-列表
          that.doorSupplierListAPI();
      }, 1000);
    },

    // 订单-列表
    orderInfoUserH5List() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      if (that.active === 0) that.params.status = "";
      else that.params.status = that.active === 1 ? 0 : 1;
      that.$api
        .siteSupplierListAPI(that.params)
        .then(function(res) {

          if (res.data.code === 200) {

            res.data.dataList.forEach(element => {

              var strLen = element.contactNumber.slice(-8, -4);
              element.contactNumber = element.contactNumber.replace(strLen, "****");

            });

            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.orderList = res.data.dataList;
            } else {
              that.orderList = [...that.orderList, ...res.data.dataList];
            }
            // 订单-列表
            that.getbadgeNumber();
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }

          }
          that.$Toast.clear();
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    // 订单-列表
    getbadgeNumber() {
      var that = this;
      that.params.status = 0;
      that.$api
        .siteSupplierListAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.badgeNumber = res.data.total;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    onClickTabs(name, title) {
      this.active = name;
      this.params.page = 1;
      if (this.activeTop == 0)
        // 预约-列表
        this.orderInfoUserH5List();
      if (this.activeTop == 1)
        // 上门-列表
        this.doorSupplierListAPI();
      console.log("name", name);
    },

    // 上门预约-列表
    doorSupplierListAPI() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      if (that.active === 0) that.params.status = "";
      else that.params.status = that.active === 1 ? 0 : 1;
      that.$api
        .doorSupplierListAPI(that.params)
        .then(function(res) {

          if (res.data.code === 200) {

            // res.data.dataList.forEach(element => {

            //   var strLen = element.contactNumber.slice(-8, -4);
            //   element.contactNumber = element.contactNumber.replace(strLen, "****");

            // });

            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.orderList = res.data.dataList;
            } else {
              that.orderList = [...that.orderList, ...res.data.dataList];
            }
            // 上门-列表
            that.getbadgeNumberDoor();
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }

          }
          that.$Toast.clear();
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    // 上门预约-列表全部
    getbadgeNumberDoor() {
      var that = this;
      that.params.status = 0;
      that.$api
        .doorSupplierListAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.badgeNumber = res.data.total;
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    onClickTabsTop(name, title) {
      this.activeTop = name;
      this.params.page = 1;
      if (name == 0)
        // 预约-列表
        this.orderInfoUserH5List();
      if (name == 1)
        // 上门-列表
        this.doorSupplierListAPI();
      console.log("name", name);
    },

    reservationVisitUpdateStatus(id) {
      var that = this;
      that.$api
        .reservationVisitUpdateStatusAPI({ id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
              onClose() {
                //下拉刷新
                that.onRefresh();
              },
            });
          } else {
            that.$Notify({
              type: "warning",
              message: res.data.message,
            });
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    // 调用拨号功能
    callPhone(phoneNumber) {
      //window.location.href = "tel://158xxxx1317";
      window.location.href = "tel://" + phoneNumber;
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.order {
  .order_centent {
    padding-top: 10px;
    border-top: 10px solid #f4f3f8;
    position: relative;

    .content_number {
      width: 17px;
      height: 17px;
      line-height: 20px;
      background: #ff5151;
      color: #fff;
      border-radius: 50%;
      text-align: center;
      font-size: 13px;
      position: absolute;
      top: 0px;
      left: 55%;
    }
  }

  .order_list {
    border-bottom: 6px solid #f3f3f3;
    padding: 20px 15px;

    .list_message {
      color: #999;
      background: #f4f3f8;
      height: 75px;
      border-radius: 10px;
      padding: 10px;
      font-size: 14px;
    }

    .list_ordernum {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5151;
        font-size: 11px;
      }
    }

    // 订单详情
    .list_detail {
      display: flex;
      padding: 15px 0px;
      justify-content: space-between;

      .list_desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 240px;
      }
    }

    .list_btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;

      .btn {
        display: flex;

        .van-button {
          margin-left: 8px;
          color: #fff !important;
        }
      }
    }

    .btn {
      font-size: 11px;
      color: #000;

      /deep/ .van-button {
        color: #333 !important;
      }
    }
  }
}

.mask_loading {
  position: fixed;
  top: 50%;
  right: 0;
  left: 0;
  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/appointmentManagement.vue